import ClusterHubPage from '../../components/ClusterHubPage';
import { CLUSTERS } from '../../data/clusterConfig';
export default function StresTukenmislikTestleriHub() {
  return <ClusterHubPage cluster={CLUSTERS['stres-ve-tukenmislik-testleri']} />;
}
